import { Component, DoCheck, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { SelectOptionModel } from '@caslink/common-client';
import { ModbusService } from '@caslink/common-client/ng-app/modbus/ModbusService';
import { IDeviceStatusBulkTemplateUpdateResult } from '../shared/models/models';

export interface DeviceBulkOperationDialogData {
    hardwareCategory: string;
}

@Component({
    selector: 'dl-device-bulk-operation',
    templateUrl: './device-bulk-operation.component.html'
})
export class DeviceBulkOperationComponent implements DoCheck, OnInit {
    public isEnabled: boolean;
    public hardwareVersions: SelectOptionModel[];

    public deviceBulkOperationFormGroup: FormGroup;
    public versionFormControl: FormControl;
    public configurationFormControl: FormControl;
    public isReady: boolean;

    configurations: any[];
    private previousHardwareVersion: number;
    private hardwareVersion: number;
    private modbusId: number;
    private configurationId: string;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: DeviceBulkOperationDialogData,
        private matDialogRef: MatDialogRef<DeviceBulkOperationComponent>,
        private modbusService: ModbusService
    ) {
        this.isEnabled = true;
        this.matDialogRef.addPanelClass('hide-background');
    }

    public ngDoCheck() {
        if (this.configurationFormControl) {
            if (this.isEnabled) {
                this.configurationFormControl.enable();
            } else {
                this.configurationFormControl.disable();
            }
        }

        if (this.previousHardwareVersion !== this.hardwareVersion) {
            this.initConfigurations(this.hardwareVersion);
            this.previousHardwareVersion = this.hardwareVersion;
        }
    }

    public ngOnInit() {
        this.modbusService.getModuleDeviceVersions(this.data.hardwareCategory).then(item => {
            this.hardwareVersions = item;
            this.hardwareVersion = item[0].value;
            this.initConfigurations(this.hardwareVersion);

            this.deviceBulkOperationFormGroup = new FormGroup({});
            this.versionFormControl = new FormControl(this.hardwareVersion);
            this.configurationFormControl = new FormControl(this.configurationId);
            this.deviceBulkOperationFormGroup.addControl('deviceVersions', this.versionFormControl);
            this.deviceBulkOperationFormGroup.addControl('deviceConfigurations', this.configurationFormControl);

            this.isReady = true;
            this.matDialogRef.removePanelClass('hide-background');
        });
    }

    public configurationChanged($event: MatSelectChange) {
        this.configurationId = $event.value;

        const selected = this.configurations.filter(configuration => configuration.id === this.configurationId);
        if (selected && selected.length === 1) {
            this.modbusId = selected[0].modbusDeviceId;
        }
    }

    public versionChanged($event: MatSelectChange) {
        this.hardwareVersion = $event.value;
    }

    confirm() {
        if (this.hardwareVersion != null) {
            const result: IDeviceStatusBulkTemplateUpdateResult = {
                hardwareVersion: this.hardwareVersion,
                configurationId: this.configurationId,
                modbusId: this.modbusId
            };
            return this.matDialogRef.close(result);
        }
    }

    cancel() {
        this.matDialogRef.close();
    }

    private initConfigurations(hardwareVersion: number) {
        this.configurationId = null;
        this.configurations = null;
        this.isEnabled = false;
        if (this.data && this.hardwareVersion) {
            this.modbusService.getModbusDeviceTemplateConfigurations(null, this.data.hardwareCategory, hardwareVersion)
                .then(data => {
                    this.isEnabled = true;
                    this.configurations = data;
                });
        }
    }
}
